import {
  takeLatest, put, select, all, call,
} from 'redux-saga/effects';
import { message } from 'antd';
import moment from 'moment-timezone';
import { get } from '@api/sharing';
import { DASHBOARD_TYPE } from '@utils/constants';
import { autoRequest } from '@api/createRequestStore';
import * as baseActions from '@store/errorDiagnostics/base/actions';
import * as birdChartActions from '@store/errorDiagnostics/birdChart/actions';
import * as dimensionTablesActions from '@store/errorDiagnostics/dimensionTables/actions';
import { updateSelectedMetrics } from '@store/viewerSessions/actions';
import { transformOldMetrics } from '@components/viewer-sessions/utils';

import { addNewSharedTab } from '../../sharedTabs/action';
import * as actions from './actions';
import * as types from './types';
import selector, { sharingResponseSelector } from './selectors';

function* afterRequest() {
  const state = yield select(sharingResponseSelector);
  if (!state) {
    return;
  }
  const { payload } = yield select(selector);
  try {
    const {
      base,
      dimensionTables,
      birdChart,
      viewerSessionsTable,
      common: { selectedCustomerId },
    } = state;
    const { interval, currentErrorCode } = base;

    yield all([
      put(
        baseActions.setBaseState({
          ...base,
          interval: {
            ...interval,
            from: moment(interval.from),
            to: moment(interval.to),
          },
        }),
      ),
      put(birdChartActions.setBirdChartState(birdChart)),
      put(dimensionTablesActions.setDimensionTablesState(dimensionTables)),
      put(
        updateSelectedMetrics(
          transformOldMetrics(viewerSessionsTable.selectedMetrics),
          currentErrorCode,
        ),
      ),
      put(
        addNewSharedTab(
          {
            id: payload,
            state,
            type: DASHBOARD_TYPE.ERROR_DIAGNOSTICS,
          },
          selectedCustomerId,
        ),
      ),
    ]);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching({ id }) {
  yield actions.fetching();
  try {
    yield autoRequest(get, types.SCOPE, id, afterRequest);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_SHARING], fetching);
}

export default [watchInitRequest, watchFetching];
